<mat-card
  class="bg-white! text-gray-900! w-full lg:max-w-[310px] lg:w-[310px] lg:h-[190px] overflow-hidden"
>
  <button
    class="md:hidden flex items-center justify-between p-4 cursor-pointer"
    type="button"
    (click)="onToggle()"
  >
    <div class="flex items-center gap-3">
      <div
        class="w-12 h-12 bg-gradient-primary-horizontal rounded-full flex items-center justify-center shrink-0"
      >
        <img [src]="'/assets/icons/' + icon" [alt]="title + ' Icon'" class="text-white!" />
      </div>
      <h4 class="text-blue-dark font-bold text-lg">{{ title }}</h4>
    </div>
    <mat-icon class="text-blue-dark transition-transform" [class.rotate-180]="isExpanded">
      expand_more
    </mat-icon>
  </button>
  <div
    class="md:hidden overflow-hidden transition-all duration-300"
    [class.max-h-0]="!isExpanded"
    [class.max-h-96]="isExpanded"
  >
    <div class="p-4 border-t border-[#C7C9C7]">
      <p class="text-navy text-base font-[450]">
        {{ description }}
      </p>
    </div>
  </div>
  <div class="hidden md:block h-full">
    <mat-card-content class="h-full">
      <div class="flex flex-col items-center justify-center gap-3 h-full">
        <div
          class="w-12 h-12 bg-gradient-primary-horizontal rounded-full flex items-center justify-center"
        >
          <img [src]="'/assets/icons/' + icon" [alt]="title + ' Icon'" class="text-white!" />
        </div>
        <h4 class="text-blue-dark font-bold text-base">{{ title }}</h4>
        <p class="text-navy text-center text-sm">
          {{ description }}
        </p>
      </div>
    </mat-card-content>
  </div>
</mat-card>
